// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H0DKAx {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;
}

.Lcb4cS {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
  text-align: center;
}

.__KlVi {
  font-size: 1rem;
  color: var(--color-text-secondary);
  margin: 0;
  text-align: center;
}

.T7r9fE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 2rem;
  border: 2px dashed var(--color-border-secondary);
  border-radius: 12px;
  background-color: var(--color-background-secondary);
  gap: 1rem;
}

.PCahNi {
  font-size: 3rem;
  opacity: 0.6;
}

.HOqRpa {
  color: var(--color-text-secondary);
  font-size: 1.1rem;
  text-align: center;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/Payment/Payment.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,mDAAmD;EACnD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 1rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n  text-align: center;\n}\n\n.subtitle {\n  font-size: 1rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n  text-align: center;\n}\n\n.placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  padding: 2rem;\n  border: 2px dashed var(--color-border-secondary);\n  border-radius: 12px;\n  background-color: var(--color-background-secondary);\n  gap: 1rem;\n}\n\n.placeholderIcon {\n  font-size: 3rem;\n  opacity: 0.6;\n}\n\n.placeholderText {\n  color: var(--color-text-secondary);\n  font-size: 1.1rem;\n  text-align: center;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `H0DKAx`,
	"title": `Lcb4cS`,
	"subtitle": `__KlVi`,
	"placeholder": `T7r9fE`,
	"placeholderIcon": `PCahNi`,
	"placeholderText": `HOqRpa`
};
module.exports = ___CSS_LOADER_EXPORT___;
